import { OmniMaisV2RestService } from './../../omni-rest/omni-mais/omni-mais-v2-rest.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OmniMaisRestService } from '../../omni-rest/omni-mais/omni-mais-rest.service';
import { ParamsConfirmacaoCPFUserChave } from './confirma-dados-assinatura';

@Injectable()
export class FichaVerificacaoSegurancaService {
  constructor(private restService: OmniMaisRestService, private restServiceV2: OmniMaisV2RestService) {}

  getTokenByCpfValidacaoSegurancao(params: ParamsConfirmacaoCPFUserChave): Observable<any> {
    return this.restServiceV2.post('customer/validate-id', params);
  }
}
